import { EditableCard, type EditableCardProps } from './components/EditableCard';
import { SimpleCard, type SimpleCardProps } from './components/SimpleCard';

export type DataCardProps =
  | ({ allowEdit: true } & EditableCardProps)
  | ({ allowEdit: false } & SimpleCardProps);

export const DataCard = (props: DataCardProps) => {
  if (props.allowEdit) {
    return <EditableCard {...props} />;
  }

  return <SimpleCard {...props} />;
};
